import { Component, Inject, OnInit } from '@angular/core';
import { SOPO_DIALOG_DATA, SopoDialogRef, SopoDialogSettings } from '../../interfaces/dialog';
import { SopoConfirmData } from '../../interfaces/confirm';


export class SopoConfirmCryptoWithdrawSettings extends SopoDialogSettings {
    data?: SopoConfirmCryptoWithdrawDataInput;
}
export interface SopoConfirmCryptoWithdrawDataInput {
    header?: string;
    okText?: string;
}

@Component({
    selector: 'app-sopo-confirm-crypto-withdraw',
    templateUrl: './sopo-confirm-crypto-withdraw.component.html',
    styleUrls: ['./sopo-confirm-crypto-withdraw.component.scss'],
    standalone: false,
})

export class SopoConfirmCryptoWithdrawComponent implements OnInit {
    header: string = 'ALERT';
    okText: string = 'PROCEED';
    checkboxChecked: boolean = false;

    constructor(
        @Inject(SOPO_DIALOG_DATA) data: SopoConfirmData,
        private sopoDialogRef: SopoDialogRef,
    ) { }

    ngOnInit() { }

    close() {
        if (!this.checkboxChecked) return;
        this.sopoDialogRef.close(true);
    }
}
